module.exports = __webpack_public_path__ + "img/panda-assist-empty.15b43816.svg";